import React from 'react'
import Button from 'srcReact/components/common2/Button'
import Icon from 'srcReact/components/icons/Icon'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import Spinner from 'srcReact/components/common2/Spinner'
import DocumentPreview from '../DocumentPreview'

export default function DeleteMediaConfirmation({
  mediaFile,
  closeModal,
  deleteMedia,
  loadingFileDeletion,
  deleteTrigged,
  fileType,
  showCloseButton = true
}) {
  const { t } = useTranslation()
  const handleCloseModal = () => {
    closeModal()
  }
  const handleDeleteMedia = () => {
    deleteMedia()
  }
  return (
    <div className={styles.deleteContainer}>
      {showCloseButton && (
        <button
          type='button'
          aria-label={t('messenger.closeModal')}
          className={styles.closeButton}
          onClick={handleCloseModal}>
          <Icon name='close24' styleModifier={styles.closeIcon} />
        </button>
      )}

      <h1 className={styles.title}>{t('messenger.deleteMedia.title')}</h1>
      {fileType === 'image' ? (
        <img className={styles.image} src={mediaFile.url} />
      ) : fileType === 'document' ? (
        <DocumentPreview fileName={mediaFile.name} extension={mediaFile.name.split('.').pop().toLowerCase()} />
      ) : null}

      <span className={styles.imageName}>{mediaFile.name}</span>

      <div className={styles.buttons}>
        <Button type='button' style='secondary' handleClick={handleCloseModal} text={t('messenger.btnCancel1')} />
        <Button type='button' handleClick={handleDeleteMedia} text={t('messenger.confirm')} />
        {loadingFileDeletion && deleteTrigged ? <Spinner /> : null}
      </div>
    </div>
  )
}
